// Recovered compiled webpack factory 94201. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "invalidateCacheByRouterState", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(69190);
  function a(e, t, r) {
    for (let a in r[1]) {
      let o = r[1][a][0],
        i = (0, n.createRouterCacheKey)(o),
        s = t.parallelRoutes.get(a);
      if (s) {
        let t = new Map(s);
        (t.delete(i), e.parallelRoutes.set(a, t));
      }
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
